import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ClaimedManufacturingOrderBuilder } from '../../models/builders/claimed-manufacturing-order.builder';

const claimedManufacturingOrderBody = (
  hash: string,
  receivers: { hash: string, isRole: boolean, isUser: boolean }[],
  comment: string,
  date: number
) => ({
  manufacturingOrderHash: hash,
  comment: comment,
  receivers: receivers,
  date: date
});

@Injectable()
export class ClaimedManufacturingOrderApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}claimed-manufacturing-orders`;
  }

  saveClaimedManufacturingOrder(
    hash: string,
    receivers: { hash: string, isRole: boolean, isUser: boolean }[],
    comment: string,
    date: number
  ) {
    return this.httpClient.post(
      this.apiUrl,
      claimedManufacturingOrderBody(hash, receivers, comment, date)
    ).pipe(map(ClaimedManufacturingOrderBuilder.fromJson));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/claimed-manufacturing-order-api.service.ts